import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from "@angular/material/dialog";
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { BrokrageService } from 'src/app/services/brokrage.service';
import { AuthService } from '@service/auth.service';
import { AlertService } from '@service/alert.service';

@Component({
    selector: 'app-trade-smart-login',
    templateUrl: './trade-smart.component.html',
    styleUrls: ['./trade-smart.component.scss']
})
export class AppTradeSmartLoginComponent implements OnInit {

    tradeKeyForm: FormGroup;
    isLoggedIn: boolean = false

    constructor(
        private matdialogRef: MatDialogRef<AppTradeSmartLoginComponent>,
        private fb: FormBuilder,
        private brokrageService: BrokrageService,
        private auth: AuthService,
        private alertService: AlertService
    ) {
    }

    ngOnInit() {
        this.auth.isLoggedIn.subscribe((res) => this.isLoggedIn = res)
        this.initializeForm();
    }

    initializeForm() {
        this.tradeKeyForm = this.fb.group({
            uid: ['', Validators.required],
            appId: ['', Validators.required],
            appSecretKey: ['', Validators.required],
            passKey: ['', Validators.required]
        });
    }

    onSubmitForm() {
        const data: any = { ...this.tradeKeyForm.value };

        const obj = Object.keys(data).map(key => key + '=' + data[key])
            .join('&');
        this.brokrageService.getTradeUserDetail(obj).subscribe({
            next: (res: any) => {
                if (res && res.data) {
                    if (this.isLoggedIn) {
                        let data = {
                            ...this.tradeKeyForm.value,
                            accessToken: res.data.accessToken
                        }
                        this.tradeSmartLogin(data)
                    } else {
                        this.matdialogRef.close({ app: data, data: res.data });
                    }
                }
            }
        });

    }

    tradeSmartLogin(data) {
        this.brokrageService.tradeSmartLogin(data).subscribe({
            next: (res) => {
                this.alertService.success('Trade Smart login Successfull')
                this.auth.UpdateUserData(false)
                this.matdialogRef.close(true)
            }
        })
    }

    closeDialog() {
        this.matdialogRef.close();
    }

    goToLogin() {
        this.brokrageService.gotoBrokerLogin('trade_smart');
    }
}
